export default "__VITE_ASSET__Uf5CKd_W__"